"use client"
import type { BLXApplications } from "config/routing"
import type React from "react"

import { VStack } from "@chakra-ui/react"

import AppNavigationHeader from "./AppNavigationHeader"

interface AppNavigationContainerProps {
    children: React.ReactNode
    app?: BLXApplications
}

const AppNavigationContainer: React.FC<AppNavigationContainerProps> = ({ children, app }) => {
    const showAccountSelector = true

    return (
        <VStack
            className='scrollbar-hide flex w-full items-start'
            spacing={6}
            maxHeight={`calc(100vh - ${showAccountSelector ? 13 : 7}rem)`}
            overflowY='auto'
            position='relative'
        >
            <AppNavigationHeader app={app} />
            <VStack spacing={0} alignItems='start' w='full' pb={[8, 8, 16]}>
                {children}
            </VStack>
        </VStack>
    )
}

export default AppNavigationContainer
